export default "__VITE_ASSET__f3653783__"